import { fn } from '@common/utils';
import { constants as kconstants, NavKendoRegister } from '@common/navkendo';
import { IPersistentSetting } from '@common/services/settingsservice';
import { CreateEditControl } from './navpropertycontrolfactory';
import { NavPropertyItem, NavPropertyValue, INavEditContext } from '@common/navdata';

/** Cell editor Widget */
export class NavCellEditor extends kendo.ui.Widget implements INavEditContext {
    AddDispose: (cb: () => any) => void;

    AddSetting<T>(name: string, s: IPersistentSetting<T>) {
      var parent = $(this.element)
        .parents()
        .addBack()
        .filter(function () {
          return $(this).data('INavEditContext') !== undefined;
        })
        .first()
        .data('INavEditContext');
      if (!parent)
        throw new Error("Missing Parent INavEditContext");

      return parent.AddSetting<T>(name, s);
    }

    get IsCellEditor() { return true; }

    GetAttachedParent(): JQuery {
      var parentEl = $(this.element)
        .parents()
        .addBack()
        .filter(function () {
          return $(this).data('INavEditContext') !== undefined;
        })
        .first(),
        parent = parentEl.data('INavEditContext');
      if (!parent)
        throw new Error("Missing Parent INavEditContext");

      return parentEl;
    }

    constructor(element: Element, options: INavCellEditorOptions) {
        super(element, options);
        this.AddDispose = (handler: Function) => this.bind(kconstants.NavDestroy, handler);
        var prop = options.Item && options.Item.ResolveProperty(options.Property),
            propItem = new NavPropertyValue(prop, options.Item),
            displayControl = CreateEditControl(propItem, this, { Mobile: this.options.Mobile });
        $(element).append(displayControl);
        this.AddDispose(fn.proxy(displayControl.blur, displayControl));
    }

    destroy() {
        this.trigger(kconstants.NavDestroy);
        super.destroy();
    }
}
NavKendoRegister(<any>NavCellEditor, "NavCellEditor");

export interface INavCellEditorOptions {
    Item: NavPropertyItem;
    Property: string;
    Mobile: boolean;
}

declare global {
    interface JQuery {
        /** Custom Cell Editor Widget */
        kendoNavCellEditor(options: INavCellEditorOptions): JQuery;
        data(key: "kendoNavCellEditor"): NavCellEditor;
    }
}
